/**
 * Steps JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class PageFlexible
 */
class PageFlexible {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.video = document.querySelector( '.js-hero-video' );
    }

    /**
     * All common events
     * 
     * @return {void}
     */
    events() {
        if ( this.video ) {
            this.initHeroVideo();
            this.removePlayerInteraction();
        }
    }

    /**
     * Prevents interaction with player controls.
     * 
     * @return {void}
     */
    removePlayerInteraction() {
        this.video.classList.add('remove-interaction');
    }

    /**
     * Inits hero video.
     *
     * @return {void}
     */
    initHeroVideo() {
        // Load the YouTube's IFrame Player API code asynchronously
        const tag = document.createElement( 'script' );
        tag.src = 'https://www.youtube.com/iframe_api';

        const firstScriptTag = document.getElementsByTagName( 'script' )[ 0 ];
        firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );

        // Define the window scope methods for YT JS API
        window.onYouTubeIframeAPIReady = function() {
            window.player = new YT.Player( 'js-hero-video', { // eslint-disable-line no-undef
                height: '1080',
                width: '1920',
                videoId: heroVideoId, // eslint-disable-line no-undef
                events: {
                    'onReady': onHeroVideoReady, // eslint-disable-line no-undef
                },
                playerVars: {
                    autoplay: 1,
                    controls: 0,
                    mute: 1,
                    rel: 0,
                    loop: 1,
                    modestbranding: 1,
                    playsinline: 1,
                    playlist: heroVideoId, // eslint-disable-line no-undef
                },
            } );
        };

        window.onHeroVideoReady = function( event ) {
            event.target.mute();
            event.target.playVideo();
        };
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}

// Export the class reference.
module.exports = PageFlexible;



// WEBPACK FOOTER //
// ./assets/scripts/page-flexible.js